<template>
    <div class="hle-print-page">
        <div class="text-end d-none d-print-block">
            <a><img src="https://staff.mmoseronelink.com/mmoser-associates.svg" alt="" width="300" height="40"></a>
        </div>
        <div class="hle-print-toolbar d-print-none">
            <router-link :to="{name : 'HleBoQBuilder', params : { id : hleProjectId, boqId : boqItem._id}}" class="hle-print-back"> 
                <i class="fa-solid fa-chevron-left"></i> {{$t('Back To Detailed Estimate')}}
            </router-link>
            <div class="hle-print-actions">
                <button class="btn hle-print-action hle-print-action--print d-print-none" @click="print"><i class="fa-solid fa-print"></i> {{$t('Print')}}</button>
                <button class="btn hle-print-action hle-print-action--download d-print-none" :class="{ 'is-loading': downloading }" :disabled="downloading" @click="downloadExcel">
                    <i v-if="!downloading" class="fa-solid fa-file-excel"></i>
                    <span>{{ $t('Download') }}</span>
                    <span v-if="downloading" class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                    <span v-if="downloading" class="visually-hidden" role="status">{{ $t('Loading') }}</span>
                </button>
            </div>
        </div>
        <div class="hle-print-document">
            <div class="hle-print-document__header">
                <div>
                    <span class="hle-print-eyebrow">{{ $t('Bidding Module.Detailed Estimate') }}</span>
                    <h4>{{ boqItem.name || '-' }}</h4>
                    <p v-if="hleProject.projectName">{{ hleProject.projectName }}</p>
                </div>
                <div class="hle-print-date">
                    <span>{{$t('Date')}}</span>
                    <strong>{{ ReformatDate(new Date())}}</strong>
                </div>
            </div>
            <div class="hle-print-note d-print-none">
                <span>{{ $t('Bidding Module.Detailed Estimate') }} {{ $t('Print') }}</span>
            </div>
            <div class="hle-print-table">
                <BoqCreatorPrintView :sectionsList="sectionsList" :IsOpenBook="false" :currencySign="boqItem.currencyId?.sign" :boqId="boqId" :imageSummaries="imageSummaries" imageContextType="high-level" />
            </div>
        </div>
    </div>
</template>
<style scoped>
.hle-print-page {
    max-width: 96rem;
    margin: 0 auto;
    padding: 1.25rem 1.6rem 2.5rem;
}

.hle-print-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    margin-bottom: 0.9rem;
}

.hle-print-back {
    display: inline-flex;
    align-items: center;
    gap: 0.48rem;
    color: #5f564d;
    font-size: 0.84rem;
    font-weight: 800;
    text-decoration: none;
}

.hle-print-back:hover,
.hle-print-back:focus {
    color: #ff671f;
}

.hle-print-actions {
    display: inline-flex;
    align-items: center;
    justify-content: flex-end;
    gap: 0.45rem;
}

.hle-print-action {
    display: inline-flex;
    min-height: 2.35rem;
    align-items: center;
    justify-content: center;
    gap: 0.42rem;
    border-radius: 0.28rem;
    padding: 0 1rem;
    font-size: 0.82rem;
    font-weight: 800;
    line-height: 1.2;
    box-shadow: none;
}

.hle-print-action--print {
    border: 1px solid #07141a;
    background: #07141a;
    color: #ffffff;
}

.hle-print-action--print:hover,
.hle-print-action--print:focus {
    border-color: #102630;
    background: #102630;
    color: #ffffff;
}

.hle-print-action--download {
    border: 1px solid #ff671f;
    background: #ff671f;
    color: #ffffff;
}

.hle-print-action--download:hover,
.hle-print-action--download:focus {
    border-color: #d9490a;
    background: #d9490a;
    color: #ffffff;
}

.hle-print-action.is-loading {
    border-color: #d7d0c5;
    background: #eee9e2;
    color: #8a837a;
    opacity: 1;
}

.hle-print-document {
    overflow: hidden;
    border: 1px solid #eadfce;
    border-radius: 0.45rem;
    background: #ffffff;
    box-shadow: 0 1.2rem 2.4rem rgba(30, 27, 22, 0.08);
}

.hle-print-document__header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 1rem;
    padding: 1.25rem 1.35rem;
    border-bottom: 1px solid #eadfce;
    background: #fffaf6;
}

.hle-print-eyebrow {
    display: block;
    color: #ff671f;
    font-size: 0.75rem;
    font-weight: 850;
}

.hle-print-document__header h4 {
    margin: 0.25rem 0 0;
    color: #111111;
    font-size: 1.24rem;
    font-weight: 850;
    line-height: 1.2;
}

.hle-print-document__header p {
    margin: 0.28rem 0 0;
    color: #5f564d;
    font-size: 0.86rem;
    font-weight: 700;
}

.hle-print-date {
    min-width: 11rem;
    color: #5f564d;
    text-align: right;
}

.hle-print-date span {
    display: block;
    font-size: 0.78rem;
    font-weight: 750;
}

.hle-print-date strong {
    display: block;
    margin-top: 0.2rem;
    color: #111111;
    font-size: 0.95rem;
    font-weight: 850;
}

.hle-print-note {
    display: flex;
    justify-content: center;
    padding: 1rem 1.25rem 0.4rem;
    color: #5f564d;
    font-size: 0.84rem;
    font-style: italic;
}

.hle-print-table {
    padding: 0.75rem 0.85rem 1rem;
}

.hle-print-table :deep(.table) {
    margin-bottom: 0;
    border-color: #eadfce;
    font-size: 0.86rem;
}

.hle-print-table :deep(.table > thead > tr > th) {
    border-color: #eadfce;
    border-bottom: 1px solid #ff671f;
    background: #ffe0d1;
    color: #ff4d13;
    font-size: 0.78rem;
    font-weight: 850;
    letter-spacing: 0;
    text-transform: none;
}

.hle-print-table :deep(.table > tbody > tr > td) {
    border-color: #eadfce;
    padding: 0.72rem 0.58rem;
    vertical-align: middle;
}

.hle-print-table :deep(.table > tbody > tr:nth-child(even) > td) {
    background: #fbfaf8;
}

.hle-print-table :deep(.table > tbody > tr:last-child > td) {
    background: #efebe6;
    font-weight: 850;
}

.hle-print-table :deep(.boq-print-image-cell) {
    width: 7rem;
    min-width: 7rem;
    text-align: center;
}

.hle-print-table :deep(.boq-print-image) {
    display: block;
    width: 6rem;
    height: 4.5rem;
    margin: 0 auto;
    border: 1px solid #eadfce;
    border-radius: 0;
    background: #ffffff;
    object-fit: contain;
}

.hle-print-table :deep(.boq-print-image-count) {
    display: block;
    margin-top: 0.22rem;
    color: #5f564d;
    font-size: 0.68rem;
    font-weight: 700;
}

@media (max-width: 768px) {
    .hle-print-page {
        padding: 1rem;
    }

    .hle-print-toolbar,
    .hle-print-document__header {
        align-items: stretch;
        flex-direction: column;
    }

    .hle-print-actions {
        width: 100%;
    }

    .hle-print-action {
        flex: 1 1 0;
    }

    .hle-print-date {
        min-width: 0;
        text-align: left;
    }
}

@media print {
    .hle-print-page {
        max-width: none;
        margin: 0;
        padding: 0;
        background: #ffffff;
    }

    .hle-print-document {
        border: 0;
        border-radius: 0;
        box-shadow: none;
    }

    .hle-print-document__header {
        padding: 0 0 0.75rem;
        background: #ffffff;
    }

    .hle-print-table {
        padding: 0;
    }

    .sticky-left {
        position: static !important;
    }
}
</style>
<script>
import {GetHighLevelBoq, GetHighLevelBoqLineItemsByBits, GetHighLevelProject, GetHleNewBoqCreatorSections, HleBoQItemExportForClient} from '@/actions/boqActions.js'
import {ReformatDate} from '@/helpers/utilities.js'
import BoqCreatorPrintView from '@/components/boq/BoqCreatorPrintView.vue'
import {GetBoqImageSummaries} from '@/actions/boqImageActions.js'
export default{
    name : 'HleBoqItemsPrint',
    components :{BoqCreatorPrintView},
    data(){
        return {
            hleProjectId : this.$route.params.id,
            hleProject: {},
            boqId : this.$route.params.boqId,
            lineItems : [],
            boqItem : {
                status : 1,
                currencyId  : {
                    sign : '',
                }
            },
            boqListParams : {
                id : this.$route.params.boqId,
                costCode : '',
                area : '',
                page : 1,
                take : 50,
                skip : 0
            },
            sectionsList : {
                sections : [],
                overAllTotal : {}
            },
            downloading : false,
            imageSummaries : {}
        }
    },
    mounted :async function(){
        const self = this
        const boqItem = await GetHighLevelBoq(self.boqId)
        self.boqItem = boqItem
        self.hleProject = await GetHighLevelProject(self.hleProjectId)
        self.sectionsList = await GetHleNewBoqCreatorSections(self.boqId,1)
        await self.LoadImageSummaries()

    },
    methods : {
        ReformatDate,
        print(){
            window.print()
        },
        GetSectionLineItemIds(sections){
            return (sections || []).flatMap(section => [
                ...(section.lineItems || []).map(item => item._id),
                ...this.GetSectionLineItemIds(section.childs)
            ]).filter(Boolean)
        },
        async LoadImageSummaries(){
            const itemIds = [...new Set(this.GetSectionLineItemIds(this.sectionsList?.sections))]
            const summaries = {}
            for(let offset = 0; offset < itemIds.length; offset += 100){
                try{
                    const result = await GetBoqImageSummaries(this.boqId,itemIds.slice(offset,offset + 100),'high-level')
                    Object.assign(summaries,result.items || {})
                }catch{
                    // Keep the document printable when an image preview is unavailable.
                }
            }
            this.imageSummaries = summaries
        },
        async downloadExcel(){
            if(this.downloading){ return }
            this.downloading = true
            try {
                await HleBoQItemExportForClient(this.boqId,this.boqItem.name)
            } finally {
                this.downloading = false
            }
        },
        async GetListByBits(){
            const self = this

            self.lineItems = []
            let willFetch = true
            self.boqListParams.skip = 0
            while(willFetch){
                const bits = await GetHighLevelBoqLineItemsByBits(self.boqListParams)
                if(bits.length!=0){
                    self.lineItems.push(...bits)
                }
                if(bits.length==self.boqListParams.take){
                    self.boqListParams.skip += 50
                }else{
                    willFetch = false
                }
            }
        },
    },
}

</script>
